<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";
import {useDisplay} from "vuetify";
import ConnectionRow from "@/components/ConnectionRow.vue";

@Options({
  computed: {
    smAndDown() {
      return useDisplay().smAndDown.value;
    }
  },
  components: {
    ConnectionRow,
    MainAppBar
  },
  data() {
    return {
      drawer: false,
      baseImg: require("@/assets/base.png"),
      banners: [
        {
          big: require("@/assets/himzőkuckó banner1.jpg"),
          small: require("@/assets/banner telefon.jpg")
        },
        {
          big: require("@/assets/himzőkuckó banner2.jpg"),
          small: require("@/assets/banner telefon2.jpg")
        },
        {
          big: require("@/assets/himzőkuckó banner3.jpg"),
          small: require("@/assets/banner telefon3.jpg")
        },
        {
          big: require("@/assets/himzőkuckó banner4.jpg"),
          small: require("@/assets/banner telefon4.jpg")
        }
      ],
      features: [
        {icon: "mdi-seal-variant", title: "Prémium minőség", text: "Modern hímzőgépeinkkel pontos és részletgazdag mintákat készítünk."},
        {icon: "mdi-shield-check", title: "Tartós kivitelezés", text: "A hímzés ellenáll a kopásnak és mosásnak, így hosszú távon is megőrzi szépségét."},
        {icon: "mdi-palette-outline", title: "Egyedi igényekre szabva", text: "Kis darabszámtól a nagy tételű gyártásig rugalmasan alkalmazkodunk elképzeléseidhez."},
        {icon: "mdi-tshirt-crew-outline", title: "Széles anyagválaszték", text: "Pólók, pulóverek, sapkák, munkaruhák, törölközők és sok más textiltermék hímzését vállaljuk."},
        {icon: "mdi-clock-fast", title: "Gyors, pontos munka", text: "Hatékony munkafolyamatainknak köszönhetően rövid határidővel dolgozunk."},
        {icon: "mdi-pencil-ruler", title: "Segítünk a tervezésben", text: "Ha nincs kész mintád, grafikai támogatást is biztosítunk az ötleted megvalósításához."},
        {icon: "mdi-cash-multiple", title: "Versenyképes árak", text: "Kiváló minőség megfizethető áron, a lehető legjobb ár-érték arányért."},
        {icon: "mdi-account-group-outline", title: "Céges és magán", text: "Legyen szó egyedi meglepetésről vagy céges ruházatról, minden ügyfelünk fontos számunkra."},
        {icon: "mdi-recycle-variant", title: "Rugalmas mennyiség", text: "Egyedi darabtól a nagyobb megrendelésig – ugyanaz a gondos kivitelezés."},
      ],
      faqs: [
        {q: "Mi az a gépi hímzés?", a: "A gépi hímzés egy automatizált folyamat, amely során számítógép-vezérelt hímzőgép szálakkal mintát varr textilre. Ez lehet logó, szöveg, grafika vagy bármilyen egyedi motívum."},
        {q: "Mire lehet gépi hímzést használni?", a: "Leggyakrabban: céges pólók, ingek, kabátok logózására; egyenruhák, munkaruhák díszítésére; törölközők, köntösök, sapkák, táskák, zászlók személyre szabására; egyedi ajándéktárgyak készítésére."},
        {q: "Milyen anyagokra lehet hímezni?", a: "Szinte minden textilre: pamut, poliészter, frottír, vászon, softshell, filc stb. Vastagabb anyagokra (pl. polár, dzseki) is lehet hímzést készíteni, csak a minta kialakításánál figyelembe vesszük az anyag tulajdonságait."},
        {q: "Hogyan kell a mintát elküldeni?", a: "A legjobb, ha vektoros formátumban (pl. .ai, .eps, .svg, .cdr) küldöd el a logót vagy mintát. Ha ez nem elérhető, jó minőségű .jpg vagy .png is megfelel, de ilyenkor plusz digitalizálásra lehet szükség."},
        {q: "Mi az a digitalizálás?", a: "A digitalizálás az a folyamat, amikor a grafikai mintát átalakítjuk hímzőgéppel olvasható formátumra (pl. .dst, .emb, .pes). Ez nem ugyanaz, mint egy képfájl megnyitása: a minta minden öltését, irányát és típusát meg kell határozni."},
        {q: "Mennyibe kerül a gépi hímzés?", a: "Az ár több tényezőtől függ: a minta mérete és bonyolultsága, a darabszám, a textil típusa, valamint az egyszeri digitalizálási díj (ha még nincs kész minta)."},
        {q: "Van minimális rendelési mennyiség?", a: "Általában nincs, de 1-2 darab esetén magasabb az egységár, mivel a gép beállítása és a digitalizálás ugyanannyi időt igényel, mint nagyobb tételnél."},
        {q: "Mennyi idő alatt készül el a hímzés?", a: "Átlagosan 3-10 munkanap, de sürgős megrendeléseknél előzetes egyeztetés után gyorsabb határidő is lehetséges."},
        {q: "Mosható-e a gépi hímzés?", a: "Igen, a hímzés nagyon tartós. Jellemzően 60 °C-ig mosható, nem kopik le, nem fakul el, mint a nyomott minták. Az anyag kezelési útmutatóját azért érdemes követni."},
        {q: "Lehet-e színes mintát is hímezni?", a: "Igen, a gépi hímzés többféle színű cérnával dolgozik. Egyszerre általában 10-15 szín használható, de a legtöbb logóhoz ez bőven elegendő."},
      ],
      socials: [
        {icon: "mdi-facebook", href: "https://www.facebook.com/kreativhimzokucko"},
        {icon: "mdi-map-marker", href: "http://maps.google.com/?q=6100 Kiskunfélegyháza Róna utca 17"},
      ]
    };
  },
  methods: {
    featureColor(i: number): string {
      return ["primary", "secondary", "accent"][i % 3];
    },
    scrollTo(id: string): void {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({behavior: "smooth"});
    },
    onConnectionClick(): void {
      this.$router.push("connection");
    }
  }
})
export default class OpenView extends Vue {
  get smAndDown(): boolean {
    return useDisplay().smAndDown.value;
  }
}
</script>

<template>
  <v-app>
    <main-app-bar></main-app-bar>
    <v-main class="hk-app-bg" :style="{ backgroundImage: 'url(' + baseImg + ')' }">

      <!-- HERO / banner-karusszel -->
      <section class="hero">
        <v-carousel
            :height="smAndDown ? 260 : 560"
            show-arrows="hover"
            cycle
            hide-delimiter-background
            :hide-delimiters="false"
        >
          <v-carousel-item v-for="(banner, i) in banners" :key="i">
            <img :src="smAndDown ? banner.small : banner.big" class="hero__img" alt="Hímzés banner" />
          </v-carousel-item>
        </v-carousel>
      </section>

      <!-- BEMUTATKOZÁS -->
      <section class="hk-section">
        <div class="hk-wrap">
          <v-row justify="center">
            <v-col cols="12" lg="9">
              <v-card class="hk-card pa-6 pa-md-10 hk-fade-up">
                <h1 class="hk-heading hk-heading--accent mb-2">Prémium minőségű gépi hímzés</h1>
                <p class="hk-subheading mb-6">Egyedi megoldások cégeknek és magánszemélyeknek</p>
                <div class="hk-lead">
                  <p class="mb-4">
                    A gépi hímzés az egyik legidőtállóbb és legelegánsabb módja a textíliák díszítésének. Kiváló választás,
                    ha tartós és exkluzív megjelenést szeretnél biztosítani ruházati termékeidnek vagy promóciós
                    ajándékaidnak.
                  </p>
                  <p class="mb-4">
                    A hímzett minták nem fakulnak, nem kopnak le, így hosszú távon is megőrzik esztétikai értéküket.
                    Modern hímzési technológiánknak köszönhetően részletgazdag, precíz és egyedi mintákat készítünk
                    a legkülönbözőbb textíliákra – legyen szó céges logóról, feliratról, emblémáról vagy névre szóló
                    ajándékról.
                  </p>
                  <p class="mb-0">
                    Szolgáltatásunkkal segítünk kiemelkedni a tömegből: egységes vállalati arculat, személyre szabott
                    ajándékok vagy exkluzív textiltermékek – bármi legyen a cél.
                  </p>
                </div>
                <div class="d-flex flex-wrap ga-3 mt-8">
                  <v-btn color="primary" size="large" variant="flat" prepend-icon="mdi-image-multiple"
                         @click="$router.push('gallery')">
                    Galéria megtekintése
                  </v-btn>
                  <v-btn color="secondary" size="large" variant="outlined" prepend-icon="mdi-phone"
                         @click="onConnectionClick">
                    Kérj ajánlatot
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>

      <!-- MIÉRT VÁLASSZ MINKET -->
      <section class="hk-section hk-section--tight">
        <div class="hk-wrap">
          <h2 class="hk-heading hk-heading--accent mb-10">Miért válassz minket?</h2>
          <v-row>
            <v-col v-for="(f, i) in features" :key="i" cols="12" sm="6" lg="4">
              <v-card class="hk-card hk-card--hover feature-card pa-6 h-100">
                <div class="feature-icon" :class="'feature-icon--' + featureColor(i)">
                  <v-icon :icon="f.icon" size="30"></v-icon>
                </div>
                <h3 class="feature-title">{{ f.title }}</h3>
                <p class="feature-text">{{ f.text }}</p>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>

      <!-- GYAKRAN ISMÉTELT KÉRDÉSEK -->
      <section class="hk-section">
        <div class="hk-wrap">
          <h2 class="hk-heading hk-heading--accent mb-10">Gyakran ismételt kérdések</h2>
          <v-row justify="center">
            <v-col cols="12" lg="9">
              <v-expansion-panels variant="accordion" class="hk-faq">
                <v-expansion-panel
                    v-for="(item, i) in faqs"
                    :key="i"
                    :title="item.q"
                    :text="item.a"
                    collapse-icon="mdi-minus"
                    expand-icon="mdi-plus"
                    rounded="lg"
                ></v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </div>
      </section>

      <!-- KAPCSOLAT -->
      <section class="hk-section hk-section--tight">
        <div class="hk-wrap">
          <h2 class="hk-heading hk-heading--accent mb-10">Lépj velünk kapcsolatba</h2>
          <v-row justify="center">
            <v-col cols="12" lg="10">
              <v-card class="hk-card pa-4 pa-md-8">
                <connection-row></connection-row>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </section>

      <!-- LÁBLÉC -->
      <footer class="hk-footer">
        <div class="hk-wrap hk-footer__inner">
          <div class="hk-footer__brand">
            <div class="font-display hk-footer__title">Kreatív Hímző Kuckó</div>
            <p class="hk-footer__tagline">Prémium gépi hímzés Kiskunfélegyházán</p>
          </div>
          <div class="hk-footer__socials">
            <span class="hk-footer__follow">Kövess minket</span>
            <v-btn
                v-for="s in socials"
                :key="s.icon"
                :icon="s.icon"
                :href="s.href"
                target="_blank"
                variant="text"
                color="white"
                size="small"
            ></v-btn>
          </div>
        </div>
        <div class="hk-footer__copy">
          © {{ new Date().getFullYear() }} — Kreatív Hímző Kuckó
        </div>
      </footer>

    </v-main>
  </v-app>
</template>

<style scoped>
/* Hero */
.hero__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

/* Feature-kártyák */
.feature-card {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: var(--hk-radius);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.feature-icon--primary {
  background: rgba(226, 76, 130, 0.12);
  color: var(--hk-primary);
}
.feature-icon--secondary {
  background: rgba(63, 125, 58, 0.12);
  color: var(--hk-secondary);
}
.feature-icon--accent {
  background: rgba(242, 169, 60, 0.16);
  color: #C8841F;
}

.feature-title {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: var(--hk-ink);
}

.feature-text {
  font-size: 1rem;
  line-height: 1.6;
  color: var(--hk-ink-soft);
  margin: 0;
}

/* FAQ */
.hk-faq :deep(.v-expansion-panel) {
  margin-bottom: 0.75rem;
  border-radius: var(--hk-radius) !important;
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(51, 41, 31, 0.06);
  overflow: hidden;
}

.hk-faq :deep(.v-expansion-panel-title) {
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 1.05rem;
  color: var(--hk-ink);
}

.hk-faq :deep(.v-expansion-panel-text) {
  font-size: 1rem;
  line-height: 1.7;
  color: var(--hk-ink-soft);
}

/* Lábléc */
.hk-footer {
  margin-top: clamp(2rem, 5vw, 4rem);
  background: linear-gradient(135deg, var(--hk-secondary), var(--hk-secondary-dark));
  color: #fff;
}

.hk-footer__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  padding-block: 2.25rem;
}

.hk-footer__title {
  font-size: 1.6rem;
  font-weight: 700;
}

.hk-footer__tagline {
  margin: 0.25rem 0 0;
  opacity: 0.85;
  font-size: 0.95rem;
}

.hk-footer__socials {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.hk-footer__follow {
  font-weight: 600;
  margin-right: 0.25rem;
}

.hk-footer__copy {
  text-align: center;
  padding: 1rem;
  font-size: 0.9rem;
  background: rgba(0, 0, 0, 0.15);
}
</style>
